const secureToken = "068c688a-fab3-4294-8e88-e2137bb26991";

export { secureToken };
